import { render, staticRenderFns } from "./MyKanban.vue?vue&type=template&id=9f1e3c46&scoped=true"
import script from "./MyKanban.vue?vue&type=script&lang=js"
export * from "./MyKanban.vue?vue&type=script&lang=js"
import style0 from "./MyKanban.vue?vue&type=style&index=0&id=9f1e3c46&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f1e3c46",
  null
  
)

export default component.exports